"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.A = exports.WrappedGatsbyLink = exports.Lead = exports.P = exports.headings = exports.H6 = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
const Link_1 = __importDefault(require("@material-ui/core/Link"));
const gatsby_1 = require("gatsby");
const useStyles = makeStyles_1.default(theme => ({
    lead: {
        marginBottom: theme.spacing(3),
        fontSize: "1.5em",
    },
    link: {
        color: theme.palette.type === "light" ? theme.palette.secondary.main : theme.palette.primary.main,
    },
}));
const Heading = (tag) => {
    const WrappedHeading = ({ children, ...props }) => {
        return (react_1.default.createElement(Typography_1.default, Object.assign({ variant: tag, gutterBottom: true }, props), children));
    };
    WrappedHeading.propTypes = {
        children: prop_types_1.default.node.isRequired,
    };
    return WrappedHeading;
};
exports.H1 = Heading("h1");
exports.H2 = Heading("h2");
exports.H3 = Heading("h3");
exports.H4 = Heading("h4");
exports.H5 = Heading("h5");
exports.H6 = Heading("h6");
exports.headings = {
    h1: exports.H1,
    h2: exports.H2,
    h3: exports.H3,
    h4: exports.H4,
    h5: exports.H5,
    h6: exports.H6,
};
exports.P = ({ children, ...props }) => (react_1.default.createElement(Typography_1.default, Object.assign({ paragraph: true }, props), children));
exports.P.propTypes = {
    children: prop_types_1.default.node.isRequired,
};
exports.Lead = ({ children }) => {
    const classes = useStyles();
    const elements = react_1.default.Children.toArray(children).map(element => {
        return react_1.default.cloneElement(element, { className: classes.lead });
    });
    return react_1.default.createElement(react_1.default.Fragment, null, elements);
};
exports.Lead.propTypes = {
    children: prop_types_1.default.any.isRequired,
};
exports.WrappedGatsbyLink = react_1.default.forwardRef((props, ref) => (react_1.default.createElement(gatsby_1.Link, Object.assign({}, props, { innerRef: ref }))));
exports.WrappedGatsbyLink.displayName = "WrappedGatsbyLink";
exports.A = ({ href, ...props }) => {
    const classes = useStyles();
    props.className = classes.link;
    if (!href) {
        return react_1.default.createElement(Link_1.default, Object.assign({}, props));
    }
    else if (href.startsWith("https://") || href.startsWith("http://") || href.startsWith("//")) {
        return react_1.default.createElement(Link_1.default, Object.assign({ target: "_blank" }, props, { href: href }));
    }
    else {
        return react_1.default.createElement(Link_1.default, Object.assign({ component: exports.WrappedGatsbyLink }, props, { to: href }));
    }
};
exports.A.propTypes = {
    href: prop_types_1.default.string.isRequired,
    target: prop_types_1.default.string,
    children: prop_types_1.default.any.isRequired,
};
//# sourceMappingURL=Typography.js.map